const searchForModels = "Search for AI Voice Models";

const $placeholders = {
  searchForModels,
};

export default $placeholders;